import React from 'react';
import styled from '@emotion/styled';
import { RichLink } from '@naf-simba/sections-rich-link';
import { RelatedArticleType } from '../../../../types/articleType';
import FallbackImage from '../../../assets/images/fallback_image.png';
import { ChargeTestType, RangeTestType } from '../../../../types/testType';
import { useDocumentUrlWithNode } from '../../hooks/Documents/useDocumentUrl';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';
import { mapMemberAccess } from '../../utils/simba/mapMemberAccess';

interface Props {
  relatedContent: (RelatedArticleType | ChargeTestType | RangeTestType)[] | undefined;
  className?: string;
}

const RelatedItem = ({ item }: { item: RelatedArticleType | ChargeTestType | RangeTestType }) => {
  const itemUrl = useDocumentUrlWithNode(item) || '';
  const { getProcessedImage } = useCloudinary();

  if (item.type === 'nafnoArticle') {
    const itemImage =
      getProcessedImage(item.image?.publicId, {
        quality: 'auto:low',
        focusMethod: item.image?.focus,
        height: 148,
        width: 148,
      })?.toURL() || FallbackImage;
    const { icon, label } = mapMemberAccess(item.paywallDetails);

    return (
      item && (
        <RelatedListItem key={`related-${itemUrl}`}>
          <RichLink
            to={itemUrl}
            title={item.name}
            media={{
              src: itemImage,
              alt: item.image?.altText ? `${item.image.altText}` : '',
            }}
            description={item.ingress}
            icon={icon}
            label={label}
          />
        </RelatedListItem>
      )
    );
  }
  return null;
};

const RelatedArticleList = ({ relatedContent, className }: Props) =>
  (relatedContent && (
    <RelatedList className={className}>
      {relatedContent.map((item) => (
        <RelatedItem item={item} key={`related-${item.slug}`} />
      ))}
    </RelatedList>
  )) ||
  null;

export default RelatedArticleList;

const RelatedList = styled.ul`
  padding: 0;
  margin: 0;
`;

const RelatedListItem = styled.li`
  list-style-type: none;
`;
